import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export interface IProps {
  open: boolean;
  onClose?: (value: string) => void;
  title?: string;
  content?: string;
  showTitle?: boolean;
  primaryAction: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    value?: string
  ) => void;
  primaryActionText?: string;
  secondaryAction: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    value?: string
  ) => void;
  secondaryActionText?: string;
}

export default function CancelConfirm(props: IProps) {
  const {
    open,
    onClose,
    title,
    showTitle,
    content,
    primaryAction,
    primaryActionText,
    secondaryAction,
    secondaryActionText,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='dialog-title'
      aria-describedby='dialog-description'>
      {showTitle && (
        <DialogTitle id='dialog-title'>
          {title ? title : 'Confirm cancellation'}
        </DialogTitle>
      )}
      <DialogContent id='dialog-description'>
        <DialogContentText>
          {content ? content : 'Are you sure you want to cancel?'}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'space-between',
        }}>
        <Button
          onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
            secondaryAction(event, 'secondary')
          }
          color='primary'>
          {secondaryActionText ? secondaryActionText : 'Back'}
        </Button>
        <Button
          onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
            primaryAction(event, 'primary')
          }
          variant='contained'
          color='primary'>
          {primaryActionText ? primaryActionText : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
